import { getQuestionHeatmap } from "../api/heatmap.api";

export async function fetchQuestionHeatmap(params) {
	const raw = await getQuestionHeatmap(params);
	const d = raw?.data || {};
	const xLabels = d.x_labels || [];
	const yLabels = d.y_labels || [];
	const points = d.heatmap || [];
	// Build a map for fast lookup
	const key = (x, y) => `${x}__${y}`;
	const valueMap = new Map(points.map(p => [key(p.x, p.y), Number(p.value) || 0]));
	// Compute min/max for scaling
	let min = Infinity, max = -Infinity;
	points.forEach(p => {
		const v = Number(p.value) || 0;
		if (v < min) min = v;
		if (v > max) max = v;
	});
	if (!isFinite(min)) min = 0;
	if (!isFinite(max)) max = 0;
	return { xLabels, yLabels, valueMap, min, max, raw };
}


